import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().min(1, 'Obavezno polje').email('Unesite validnu email adresu'),
  password: z.string().min(1, 'Obavezno polje'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'Obavezno polje').email('Unesite validnu email adresu'),
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    newPassword: z.string().min(6, 'Minimum 6 karaktera'),
    confirmPassword: z.string().min(1, 'Obavezno polje'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Lozinke se ne poklapaju',
    path: ['confirmPassword'],
  });

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Obavezno polje'),
    newPassword: z.string().min(6, 'Minimum 6 karaktera'),
    confirmPassword: z.string().min(1, 'Obavezno polje'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Lozinke se ne poklapaju',
    path: ['confirmPassword'],
  });

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
